<template>
  <TableColumnPrimary header=""
                      v-bind="attrs"
                      v-on="$listeners"
                      :rows="dummyRows"
                      :width="width">
    <template v-slot:row>
      <div />
    </template>
  </TableColumnPrimary>
</template>

<script>
  import TableColumnPrimary from '@modules/table/table-column-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TableEmptyColumnPrimary',
    inheritAttrs: false,
    components: {
      TableColumnPrimary,
    },
    props: {
      rowsLength: { type: Number, required: false, default: 0 },
      width: { type: String, required: false, default: '100%' },
    },
    data: function () {
      return {
        attrs: {
          backgroundColor: 'transparent',
        },
      };
    },
    created: function () {
      this.attrs = {
        ...this.attrs,
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      dummyRows: function () {
        return new Array(this.rowsLength);
      },
    },
  };
</script>
